import {Component, ElementRef, EventEmitter, Inject, OnInit, Output, ViewChild} from '@angular/core';
import {FormBuilder, FormGroupDirective, Validators} from '@angular/forms';
import {Constants} from '../../../../../core/services/constants.service';
import {HttpService} from '../../../../../core';
import {ToastrService} from 'ngx-toastr';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-add-property-dialog',
  templateUrl: './add-property-dialog.component.html',
  styleUrls: ['./add-property-dialog.component.scss'],
})
export class AddPropertyDialogComponent implements OnInit {

  @ViewChild('formDirective') private formDirective: FormGroupDirective;
  @ViewChild('termsInput') private termsInput: ElementRef;

  project: any;
  isSubmitted: boolean;
  reactiveForm: any;
  selectedTermsAttachments = [];
  listingDateTimestamp = '';
  soldDateTimestamp = '';
  settledDateTimestamp = '';

  internalArea = 0.0;
  externalArea = 0.0;
  totalArea = (this.internalArea + this.externalArea).toFixed(2);

  levelRegex = /^(0|[1-9]|[1-9][0-9]|[1-9][0-9][0-9]|[g|G]|[g|G][a-c|A-C]|[l|L][g|G]|[l|L]|[b|B]|[b|B][1-5])$/;

  numReg = /^([0-9]|[1-9]\d+)(\.\d{2})?$/;

  isFileTooLarge: boolean;
  isCreating: boolean;

  today = new Date().getTime();

  constructor(
    private formBuilder: FormBuilder,
    private httpService: HttpService,
    private toastrService: ToastrService,
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.reactiveForm = this.formBuilder.group({
      type: [''],
      pNumber: [''],
      lotNumber: [''],
      commission: [''],
      commissionUnit: ['%'],
      status: [''],
      orientation: [''],
      view: [''],
      description: [''],
      listingDate: [{value: '', disabled: true}],
      soldDate: [{value: '', disabled: true}],
      settledDate: [{value: '', disabled: true}],
      level: ['0', [Validators.pattern(this.levelRegex)]],
      totalPrice: [''],
      // landPrice: [''],
      // housePrice: [''],

      bed: ['0'],
      bath: ['0', [Validators.pattern('^[0-9]*[.,]?[0-9]*$')]],
      study: ['0'],
      // livingRoom: [''],
      car: ['0'],
      storeys: ['0'],

      internalArea: [0.0],
      externalArea1: [0.0],
      externalArea2: [0.0],
      totalArea: [0.0],
      landArea: [''],

      tags: [''],

      estimatedRates: [''],
      estimatedRentalReturns: [''],
      estimatedOwnersCorporationFee: [''],
      extraCost: [''],
      stampDuty: [''],
      councilFee: [''],
      buildingId: [''],
    });
  }

  ngOnInit(): void {
    var initVal = 0;

    this.reactiveForm.patchValue({
      internalArea: initVal.toFixed(2),
      externalArea1: initVal.toFixed(2),
      externalArea2: initVal.toFixed(2),
      totalArea: initVal.toFixed(2),
    });

    this.project = this.data.project;

    if (this.project.buildings && this.project.buildings.length == 1) {
      this.reactiveForm.patchValue({
        buildingId: this.project.buildings[0].id,
      })
    }
  }

  valueChange($event) {

    this.reactiveForm.patchValue({
      internalArea: parseFloat(this.reactiveForm.get('internalArea').value).toFixed(2),
      externalArea1: parseFloat(this.reactiveForm.get('externalArea1').value).toFixed(2),
      externalArea2: parseFloat(this.reactiveForm.get('externalArea2').value).toFixed(2),
    });

    this.reactiveForm.patchValue({
      totalArea: (
        parseFloat(this.reactiveForm.get('internalArea').value) +
        parseFloat(this.reactiveForm.get('externalArea1').value) +
        parseFloat(this.reactiveForm.get('externalArea2').value)
      ).toFixed(2),
    });
  }

  valueChange2($event) {
    this.reactiveForm.patchValue({
      bath: parseFloat(this.reactiveForm.get('bath').value).toFixed(2),
      car: parseFloat(this.reactiveForm.get('car').value).toFixed(2),
    });
  }

  getListingDate(event) {
    this.listingDateTimestamp = new Date(event.value).getTime().toString();
  }

  getSoldDate(event) {
    this.soldDateTimestamp = new Date(event.value).getTime().toString();
  }

  getSettledDate(event) {
    this.settledDateTimestamp = new Date(event.value).getTime().toString();
  }

  createProperty(flag: boolean) {
    // window.scrollTo(0,0);
    if (this.reactiveForm.invalid) {
      return;
    }
    const fd = new FormData();
    // fd.append('projectId', this.project.id);
    fd.append('projectId', this.reactiveForm.get('buildingId').value);
    fd.append('projectTypeId', this.reactiveForm.get('type').value);
    fd.append('unitNum', this.reactiveForm.get('pNumber').value);

    fd.append('status', this.reactiveForm.get('status').value);
    fd.append('internalArea', this.reactiveForm.get('internalArea').value);
    fd.append('externalArea', '0');
    fd.append('totalArea', this.reactiveForm.get('totalArea').value);

    // if (this.reactiveForm.get('landArea').value) {
    //   fd.append('landArea', this.reactiveForm.get('landArea').value);
    // }

    if (this.reactiveForm.get('externalArea1').value || this.reactiveForm.get('externalArea2').value) {
      fd.append(
        'externalAreas',
        JSON.stringify({
          externalArea1: this.reactiveForm.get('externalArea1').value,
          externalArea2: this.reactiveForm.get('externalArea2').value,
        }),
      );
    }

    if (this.reactiveForm.get('landArea').value) {
      fd.append('landArea', this.reactiveForm.get('landArea').value);
    }

    if (this.reactiveForm.get('totalPrice').value) {
      fd.append('price', this.reactiveForm.get('totalPrice').value);
    }

    if (this.reactiveForm.get('lotNumber').value) {
      fd.append('lotNum', this.reactiveForm.get('lotNumber').value);
    }
    if (this.reactiveForm.get('commission').value) {
      fd.append('commissionFee', this.reactiveForm.get('commission').value);
    }
    // max-width: 20
    if (this.reactiveForm.get('commissionUnit').value) {
      fd.append('commissionFeeUnit', this.reactiveForm.get('commissionUnit').value);
    }

    // fd.append('tagIds[]', this.reactiveForm.get('tagIds').value);
    if (this.reactiveForm.get('orientation').value) {
      fd.append('aspect', this.reactiveForm.get('orientation').value);
    }
    if (this.reactiveForm.get('view').value) {
      fd.append('view', this.reactiveForm.get('view').value);
    }

    if (this.reactiveForm.get('description').value) {
      fd.append('notes', this.reactiveForm.get('description').value);
    }
    if (this.reactiveForm.get('level').value) {
      if (!isNaN(this.reactiveForm.get('level').value)) {
        fd.append('level', this.reactiveForm.get('level').value);
      } else {
        console.log('bbb');
        switch (this.reactiveForm.get('level').value.toUpperCase()) {
          case 'GC':
            fd.append('level', '-1');
            break;
          case 'GB':
            fd.append('level', '-2');
            break;
          case 'GA':
            fd.append('level', '-3');
            break;
          case 'G':
            fd.append('level', '-4');
            break;
          case 'LG':
            fd.append('level', '-5');
            break;
          case 'L':
            fd.append('level', '-6');
            break;
          case 'B':
            fd.append('level', '-7');
            break;
          case 'B1':
            fd.append('level', '-8');
            break;
          case 'B2':
            fd.append('level', '-9');
            break;
          case 'B3':
            fd.append('level', '-10');
            break;
          case 'B4':
            fd.append('level', '-11');
            break;
          case 'B5':
            fd.append('level', '-12');
            break;
          default:
            break;
        }
      }
    } else {
      fd.append('level', '0');
    }

    fd.append('bedRoom', this.reactiveForm.get('bed').value);
    fd.append('bathRoom', this.reactiveForm.get('bath').value);
    fd.append('studyRoom', this.reactiveForm.get('study').value);
    fd.append('carParking', this.reactiveForm.get('car').value);
    fd.append('storeys', this.reactiveForm.get('storeys').value);
    // if (this.reactiveForm.get('livingRoom').value) {
    //   fd.append('liveRoom', this.reactiveForm.get('livingRoom').value);
    // }

    if (this.soldDateTimestamp) {
      fd.append('soldTime', this.soldDateTimestamp);
    }

    if (this.settledDateTimestamp) {
      fd.append('settleTime', this.settledDateTimestamp);
    }

    if (this.listingDateTimestamp) {
      fd.append('listTime', this.listingDateTimestamp);
    }

    if (this.reactiveForm.get('estimatedRates').value) {
      fd.append('estimatedRates', this.reactiveForm.get('estimatedRates').value);
    }
    if (this.reactiveForm.get('estimatedRentalReturns').value) {
      fd.append('estimatedRentalReturns', this.reactiveForm.get('estimatedRentalReturns').value);
    }
    if (this.reactiveForm.get('estimatedOwnersCorporationFee').value) {
      fd.append('estimatedOwnersCorporationFee', this.reactiveForm.get('estimatedOwnersCorporationFee').value);
    }

    if (this.reactiveForm.get('extraCost').value) {
      fd.append('extraCost', this.reactiveForm.get('extraCost').value);
    }

    if (this.reactiveForm.get('stampDuty').value) {
      fd.append('stampDuty', this.reactiveForm.get('stampDuty').value);
    }
    if (this.reactiveForm.get('councilFee').value) {
      fd.append('councilFee', this.reactiveForm.get('councilFee').value);
    }

    // 条款文件
    if (this.selectedTermsAttachments.length > 0) {
      this.selectedTermsAttachments.forEach((file) => {
        fd.append('files', file);
      });
    }

    this.isCreating = true;
    this.httpService.createProperty(fd).subscribe((res: any) => {
      console.log(res);
      if (res.code === 1) {

        this.termsInput.nativeElement.value = '';
        this.toastrService.success('One property has been added.');

        this.isCreating = false;
        this.dialogRef.close({
          newProperty: res.data, projectId: this.reactiveForm.get('buildingId').value,
          flag: flag
        });
      } else if (res.code === 0) {
        this.toastrService.error('Failed to add property');
        this.isCreating = false;
      }
    });
  }

  onFileChangeForTerms(event) {
    this.isFileTooLarge = false;
    console.log(event.target.files, event.target.files[0]);
    if (event.target.files && event.target.files[0]) {
      // const filesAmount = event.target.files.length;
      for (let i = 0; i < 1; i++) {
        // const reader = new FileReader();
        console.log('hi:', event.target.files[i]);
        if (event.target.files[i].size <= Constants.UPLOAD_TERMS_FILE_SIZE) {
          this.selectedTermsAttachments.push(event.target.files[i]);
        } else {
          this.isFileTooLarge = true;
        }
        console.log(this.selectedTermsAttachments);

        // reader.onload = (e: any) => {
        //   console.log(e.target.result);
        //   this.images.push(e.target.result);
        //
        //   this.picturesForm.patchValue({
        //     fileSource: this.images
        //   });
        // };
        //
        // reader.readAsDataURL(event.target.files[i]);
      }
    }
  }

  typeChange(e) {
    if (e.target.value !== '3') {
      this.reactiveForm.get('level').value = '0';
    }
  }

  cancel() {
    this.dialogRef.close();
  }

  validateInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const regex = /^\d*\.?\d*$/;
    if (!regex.test(input.value)) {
      input.value = '0';
    }
  }
}
